import { Col, View } from '@amzn/stencil-react-components/layout';
import {
  MessageBanner,
  MessageBannerType
} from '@amzn/stencil-react-components/message-banner';
import React from 'react';

interface AutoDismissMessageBannerProps {
  bannerText?: string;
  bannerType?: MessageBannerType.Success | MessageBannerType.Error;
  bannerAutoDismissTime?: number;
  flipVisibility: Function;
}
const AutoDismissMessageBanner = ({
  bannerText,
  bannerType,
  bannerAutoDismissTime,
  flipVisibility
}: AutoDismissMessageBannerProps) => {
  const isError = bannerType === MessageBannerType.Error;
  // Errors must not auto-dismiss: the operator needs time to read and act on
  // them (and, for modal flows, to expand the ErrorDetailsPanel). They remain
  // dismissible. Success/info banners keep their auto-dismiss timer.
  const autoDismissAfter = isError ? undefined : bannerAutoDismissTime;
  return (
    <Col gridGap="S200">
      {/* Success/info banners are short — pin them to a fixed height to avoid
          layout shift. Errors can carry longer backend messages and must not be
          clipped, so let the error banner size to its content. */}
      <View height={isError ? undefined : 50}>
        <MessageBanner
          type={bannerType}
          isDismissible
          autoDismissAfter={autoDismissAfter}
          onDismissed={() => {
            flipVisibility();
          }}
        >
          {bannerText}
        </MessageBanner>
      </View>
    </Col>
  );
};
export default AutoDismissMessageBanner;
